import { gql } from '@apollo/client';

// Supporting relationships where the caller's working org is the supportedOrganisation
// (i.e. the organisations that support us). Inverse of supportedCommunities.
export const GET_PARTNERSHIPS = gql`
query Partnerships {
  partnerships {
    id
    supporterOrganisationId
    supporterName
    scope
    scopeLabel
  }
}`;
